export default __webpack_public_path__ + "static/media/both-kitties-on-blanket.d91eefff.png";